import { useAuthContext } from 'src/auth/hooks';
import { useOrganizationContext } from 'src/context/organization';
import { resolveEffectiveRole } from 'src/utils/roles';

/**
 * Returns the user's effective role for the currently selected organization, normalized to
 * canonical role codes (superadmin, manager, user, legislative_member).
 * See src/utils/roles.js for the rules — the API enforces the same ones.
 */
export const useEffectiveRole = () => {
  const { user } = useAuthContext();
  const { roleInSelectedOrganization } = useOrganizationContext();
  const globalRole = user?.users_user_roles?.[0]?.user_roles_roles?.code;

  return resolveEffectiveRole(globalRole, roleInSelectedOrganization);
};
